import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import * as _ from 'lodash';
import { SettingsmanagerService } from './../../services/settingsmanager.service';
import { Position, Rental } from 'src/app/classes';
import { WsmanagerService } from 'src/app/services/wsmanager.service';
import { TranslateService } from '@ngx-translate/core';

declare let google: any;

@Component({
  selector: 'app-pathmap',
  templateUrl: './pathmap.component.html',
  styleUrls: ['./pathmap.component.scss']
})
export class PathmapComponent implements OnInit {

  @Input() rental: Rental;
  @ViewChild('mapContainer') mapContainer: ElementRef;
  @Output() mapStaticUrlGenerated = new EventEmitter<string>(); 

  apiKey = null;
  positions: Position[];
  startCoordinates = [];
  stopCoordinates = [];
  rentalCoordinates: google.maps.LatLng[] = []; 
  public map: google.maps.Map = null;

  constructor(
    private translate: TranslateService,
    private wsManager: WsmanagerService,
    private settingsManager: SettingsmanagerService,
  ) {
    this.apiKey = this.settingsManager.getGoogleMapsApiKey();
  }
 
  ngOnInit() {
    this.fillMap(); 
  }

  private initMap(): void {
    const mapOptions = {
      center: new google.maps.LatLng(),
      zoom: 8,
      styles: [
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
      ],
    };
    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);
  }

  fillMap(): void {
    this.wsManager.getRentalPoisitions(this.rental.id)
        .subscribe((positions) => {
          if (positions.length) {
            this.positions = positions;
            this.startCoordinates.push([positions[0].latitude, positions[0].longitude]);
            this.stopCoordinates.push([positions[positions.length-1].latitude, positions[positions.length - 1].longitude]);
            this.rentalCoordinates = this.positions.map((pos) => new google.maps.LatLng(pos.latitude, pos.longitude));
            this.initMap(); 
            this.addMarkersAndPolyline();
            this.centerMap();         
          } else {
            console.log('ERR: no positions found for the rental:', this.rental.id);
          }
        }, (err) => {
          {
            console.log('ERR:', err);
          }
        });
  }
 
  private addMarkersAndPolyline(): void {
    if (this.rentalCoordinates.length > 0) {
      const startMarker = new google.maps.Marker({
        position: this.rentalCoordinates[0],
        map: this.map,
        title: this.translate.instant('Start of rental'),
        icon: {
          url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
          scaledSize: new google.maps.Size(50, 50)
        }
      });
      const endMarker = new google.maps.Marker({
        position: this.rentalCoordinates[this.rentalCoordinates.length - 1],
        map: this.map,
        title: this.translate.instant('End of rental'),
        icon: {
          url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
          scaledSize: new google.maps.Size(50, 50)
        }
      });   
      const polyline = new google.maps.Polyline({
        path: this.rentalCoordinates,
        geodesic: true,
        strokeColor: 'blue',
        strokeOpacity: 0.7,
        strokeWeight: 8
      });  
      polyline.setMap(this.map);
    } else {
      console.log('No coordinates available to plot the route.');
    }
  }

  centerMap(): void {
    if (this.map && this.rentalCoordinates.length > 0) {
      this.fitBoundsToPath();
    } else {
      console.log('Error: The map has not been initialized or there are no coordinates.');
    }
  }

  private fitBoundsToPath(): void {
    if (this.map && this.rentalCoordinates.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      this.rentalCoordinates.forEach(coord => bounds.extend(coord));
      this.map.fitBounds(bounds);
    } else {
      console.log('Error: Unable to calculate map boundaries.');
    }
  }

  generateStaticMap(): void {
    if (this.rentalCoordinates.length > 0) {
      const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
      const size = 'size=600x400';
      const startMarker = `markers=color:green|label:S|${this.startCoordinates[0][0]},${this.startCoordinates[0][1]}`;
      const endMarker = `markers=color:red|label:E|${this.stopCoordinates[0][0]},${this.stopCoordinates[0][1]}`;
    
      const polylinePath = this.rentalCoordinates
        .map(coord => `${coord.lat()},${coord.lng()}`)
        .join('|');
      const path = `path=color:blue|weight:5|${polylinePath}`;
    
      const apiKeyParam = `key=${this.apiKey}`;
    
      const staticMapUrl = `${baseUrl}?${size}&${startMarker}&${endMarker}&${path}&${apiKeyParam}`;
      
      this.mapStaticUrlGenerated.emit(staticMapUrl);
    } else {
      this.mapStaticUrlGenerated.emit('');
    }
  }
}